<template  >
<v-layout column fill-height="">
    <not-toolbar-sub :not="not"></not-toolbar-sub>

    <!-- //access page -->
    <not-access-deny-page 
        v-if="!accessPage"
        :not="not"
        :notShow="true"/> 
    <!-- //page -->
    <div v-else>
        <not-page-spinner 
            :notShow="true" 
            :not="not"
            v-if="!page_show"/>
        <div v-else class="ma-10 ">
            <v-toolbar color="primary" dark="" tile=""  >
                <v-toolbar-title>
                    MANAGE PROFILE
                </v-toolbar-title>
                <v-spacer></v-spacer> 
                <v-btn @click="update()" color="white" outlined="" rounded="" class="ml-2"><v-icon size="18" class="pr-1">mdi-update</v-icon>Update</v-btn>
                    
            </v-toolbar>

            <v-card class="pa-2" tile="">
                <v-card-title>
                    ACCOUNT DETAILS 
                </v-card-title>
                <v-list>
                    <v-list-item>
                        <v-list-item-action><v-icon>mdi-account</v-icon></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Full Name</v-list-item-title>
                            <v-list-item-subtitle>{{ud?ud.name:"..."}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action><v-icon>mdi-email</v-icon></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Email Address</v-list-item-title>
                            <v-list-item-subtitle>{{us?us.email:"..."}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action><v-icon>mdi-phone</v-icon></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Phone Number</v-list-item-title>
                            <v-list-item-subtitle>{{ud?ud.phone:"..."}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action><v-icon>mdi-file-tree</v-icon></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>User Group</v-list-item-title>
                            <v-list-item-subtitle>{{JOINED_ud?JOINED_ud.user_group_name:"..."}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action><v-icon>mdi-timer</v-icon></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Created At</v-list-item-title>
                            <v-list-item-subtitle>{{not.convertDate(ud?ud.created_at:"")}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                    <v-list-item>
                        <v-list-item-action><v-icon>mdi-timer-off</v-icon></v-list-item-action>
                        <v-list-item-content>
                            <v-list-item-title>Updated At</v-list-item-title>
                            <v-list-item-subtitle>{{not.convertDate(ud?ud.updated_at:"")}}</v-list-item-subtitle>
                        </v-list-item-content>
                    </v-list-item>
                </v-list>
            </v-card> 

            <v-card tile="" class="mt-5">
                <v-toolbar color="primary" dark="" tile=""  >
                    <v-toolbar-title>
                        ACCESS / PERMISSIONS
                    </v-toolbar-title>
                    <v-spacer></v-spacer> 
                    <!-- <v-btn @click="update()" color="white" outlined="" rounded="" class="ml-2"><v-icon size="18" class="pr-1">mdi-update</v-icon>Update</v-btn> -->
                        
                </v-toolbar>
                <div > 
                    <!-- Read -->
                    <div > 
                        <v-list  subheader class="pa-5" v-if="p_read">
                            <v-subheader>READ PERMISSION</v-subheader>
                            <div   v-for="(permission, index) in p_read" :key="index">
                                <v-list-item > 
                                    <v-list-item-avatar>
                                        <v-icon>mdi-folder-key</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        {{permission.name}} 
                                    </v-list-item-content>
                                    <v-list-item-action class="ma-0 pa-0" height="0"> 
                                            <v-layout align-center="" justify-center="">
                                                    <v-icon v-if="p_value(permission)" color="accent" size="45">radio_button_checked</v-icon>
                                                    <v-icon v-else size="45">radio_button_unchecked</v-icon> 
                                            </v-layout>
                                    </v-list-item-action>
                                </v-list-item>   
                            </div>
                        </v-list>  
                    </div>
                    <!-- write -->
                    <div >
                        <v-divider></v-divider>
                        <v-list  subheader class="pa-5" v-if="p_write">
                            <v-subheader>WRITE PERMISSION</v-subheader>
                            <div   v-for="(w_permission, index2) in p_write" :key="index2">
                                <v-list-item  > 
                                    <v-list-item-avatar>
                                        <v-icon>mdi-folder-key</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        {{w_permission.name}} 
                                    </v-list-item-content>
                                    <v-list-item-action class="ma-0 pa-0" height="0"> 
                                            <v-layout align-center="" justify-center="">
                                                    <v-icon v-if="p_value(w_permission)" color="accent" size="45">radio_button_checked</v-icon>
                                                    <v-icon v-else size="45">radio_button_unchecked</v-icon> 
                                            </v-layout>
                                    </v-list-item-action>
                                </v-list-item>
                            </div>
                        </v-list> 
                    </div>
                    <!-- Delete -->
                    <div >
                        <v-divider></v-divider>
                        <v-list  subheader class="pa-5" v-if="p_delete">
                            <v-subheader>DELETE PERMISSION</v-subheader>
                            <div   v-for="(permission, index) in p_delete" :key="index">
                                <v-list-item  > 
                                    <v-list-item-avatar>
                                        <v-icon>mdi-folder-key</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        {{permission.name}}
                                    </v-list-item-content>
                                    <v-list-item-action class="ma-0 pa-0" height="0"> 
                                            <v-layout align-center="" justify-center="">
                                                    <v-icon v-if="p_value(permission)" color="accent" size="45">radio_button_checked</v-icon>
                                                    <v-icon v-else size="45">radio_button_unchecked</v-icon> 
                                            </v-layout>
                                    </v-list-item-action>
                                </v-list-item>
                            </div>
                        </v-list> 
                    </div>
                    <!-- Pages -->
                    <div >
                        <v-divider></v-divider>
                        <v-list  subheader class="pa-5" v-if="p_pages">
                            <v-subheader>PAGES PERMISSION</v-subheader>
                            <div   v-for="(permission, index) in p_pages" :key="index">
                                <v-list-item  > 
                                    <v-list-item-avatar>
                                        <v-icon>mdi-folder-key</v-icon>
                                    </v-list-item-avatar>
                                    <v-list-item-content>
                                        {{permission.name}} 
                                    </v-list-item-content>
                                    <v-list-item-action class="ma-0 pa-0" height="0"> 
                                            <v-layout align-center="" justify-center="">
                                                    <v-icon v-if="p_value(permission)" color="accent" size="45">radio_button_checked</v-icon>
                                                    <v-icon v-else size="45">radio_button_unchecked</v-icon> 
                                            </v-layout>
                                    </v-list-item-action>
                                </v-list-item>
                            </div>
                        </v-list> 
                    </div>
                    <v-layout class="px-5">
                        <v-spacer></v-spacer>
                        <!-- <v-btn color="primary" :loading="input.loading" @click="saveUserGroupPermissions()" >Save Changes</v-btn> -->
                    </v-layout>
                    <br> <br>
                </div> 
            </v-card>
        </div> 
    </div>

    <v-dialog v-model="dialog_update_user" persistent max-width="600px"> 
        <v-card>
            <v-card-title class="primary white--text" dark>
                <span class="headline">UPDATE MY ACCOUNT</span>
                <v-spacer></v-spacer>
                <!-- <v-btn color="white" outlined="" rounded="" class="ml-2"><v-icon size="" class="pr-1">mdi-file-excel-outline</v-icon> EXCEL</v-btn> -->
            </v-card-title>
            <v-card-text> 
                <v-container grid-list-lg>
                    <br>
                    <form id="itemDetailForm" @submit.prevent="submited()">
                        <v-layout row wrap class="pa-1">   
                            <!-- Title -->
                            <v-flex xs12> 
                                <v-text-field 
                                    required  
                                    type="text"
                                    filled="" 
                                    v-model="input.name" 
                                    label="Name"/>  
                            </v-flex>    
                            <v-flex xs12> 
                                <v-text-field 
                                    required  
                                    type="number"
                                    filled="" 
                                    v-model="input.phone" 
                                    label="Phone Number"/>  
                            </v-flex>  
                            <v-flex xs12>
                                <v-text-field  
                                    required
                                    type="password"
                                    filled="" 
                                    v-model="input.old_password" 
                                    label="Old Password" />  
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  
                                    type="password"
                                    filled="" 
                                    v-model="input.password" 
                                    label="New Password" />  
                            </v-flex> 
                            <v-flex xs12 sm6>
                                <v-text-field  
                                    type="password"
                                    filled=""  
                                    v-model="input.confirm_password" 
                                    label="Cnfirm Password" />  
                            </v-flex> 
                             
                        <v-btn type="submit" style="display:none;" class="" id='submitBTN'>submit</v-btn>
                        </v-layout>
                        <v-card-actions>
                        <v-spacer></v-spacer>
                        <v-btn color="primary" text="" @click="dialog_update_user=false">CANCEL</v-btn>
                        <v-btn color="primary" :loading="input.loading" dark="" type="submit">UPDATE</v-btn>
                        </v-card-actions>
                    </form> 
                </v-container>
                <small>Click Update button to save changes</small>
            </v-card-text> 
        </v-card>
    </v-dialog>
</v-layout>
</template>

<script> 
    
   let pageName = 'MyProfile'
    export default{
        name: pageName,
        props:['not'],  
        data: () => ({ 
            page_show: false, 
            dialog_update_user:false,
            input:{},
            search: '',
            headers: [
                { text: 'NAME',align: 'left',sortable: true, value: 'name',},
                { text: 'EMAIL', sortable: true, value: 'email' },
                { text: 'ROLE', value: 'role' }, 
                { text: 'ACTION',align: 'center', value: 'action' },
            ],
            
             
        }), 
        beforeCreate(){
             
        },
        created(){
            this.EventBus.$on('notYesDialog', this.notYesDialog); 

        },
        mounted() {   
            this.pageLoad(1000)
        },
        computed:{ 
            accessPage(){
                return this.not.ACCESS_PAGE(this.$route.name)
            },
            us(){
                return this.not.us
            },
            usr(){
                return this.not.usr
            },
            uds(){
                return this.not.uds
            },
            ud(){
              return this.not.ud
            },

            loading(){  
                return this.not.loading
            },
            processes(){  
                return this.not.processes
            }, 
            responses(){  
                return this.not.responses
            }, 
             

            JOINED_ud(){
                let ud = this.ud
                let JOIN_UD = this.not.JOIN_UD(ud)
                return JOIN_UD
            },

            p_read(){ 
                let jn = this.JOINED_ud  
                if(!jn){return null} 
                let pm = jn.permissions 
                if(!pm){return null} 
                let obj = pm.read  
                let data = []
                for (const key in obj) {
                    let sms = obj[key]
                    data.push({ 
                        key: key,
                        ...sms
                    }) 
                }
                return data
            },
            p_write(){
                let jn = this.JOINED_ud 
                if(!jn){return null} 
                let pm = jn.permissions 
                if(!pm){return null} 
                let obj = pm.write  
                let data = []
                for (const key in obj) {
                    let sms = obj[key]
                    data.push({ 
                        key: key,
                        ...sms
                    }) 
                }
                return data
            },
            p_delete(){
                let jn = this.JOINED_ud 
                if(!jn){return null} 
                let pm = jn.permissions 
                if(!pm){return null} 
                let obj = pm.delete  
                let data = []
                for (const key in obj) {
                    let sms = obj[key]
                    data.push({ 
                        key: key,
                        ...sms
                    }) 
                }
                return data
            },
            p_pages(){
                let jn = this.JOINED_ud 
                if(!jn){return null} 
                let pm = jn.permissions 
                if(!pm){return null} 
                let obj = pm.pages  
                let data = []
                for (const key in obj) {
                    let sms = obj[key]
                    data.push({ 
                        key: key,
                        ...sms
                    }) 
                }
                return data
            },
            
            
        },
        //------------methods---------------
        methods: { 
            clicked(){},
            notYesDialog(action){
                if (action) {
                    if (action.code ===pageName+'=UPDATE-USER') {
                        if (this.input.check) { 
                            this.input.check = false 
                            console.log(action.details,'action.details....');
                            this.$store.dispatch("fi_updateUser",action.details) 
                        } 
                    }
                    if (action.code ===pageName+'=UPDATE-USER-SUCCESS') {
                        this.dialog_update_user = false
                    }
                    if (action.code ===pageName+'=UPDATE-USER-ERROR') {
                        console.log("............."); 
                    }
                }
            },
            submited(){
                if (this.input.password!==this.input.confirm_password) {
                    this.not.notDialog(true,true,"PASSWORD ERROR","Password mismatch. please,check and try again","OK")
                }else{
                    this.input.check = true
                    this.not.notDialog(true,true,"UPDATE USER",'Are you sure you want update account','CANCEL',"UPDATE",{
                        code:pageName+"=UPDATE-USER",
                        details:this.input
                    }) 
                }
            },
            update(){
                let us = this.us
                let ud = this.ud

                this.input = {}

                

                //add role
                if (us) {
                    if (!ud) {
                       if (us.email==="admin@masoathu.com") {
                           this.input.role = "administrator"
                       } else {
                           this.input.role = "user"
                       } 
                    } else {
                        if (!ud.role) {
                            if (us.email==="admin@masoathu.com") {
                                this.input.role = "administrator"
                            } else {
                                this.input.role = "user" 
                            } 
                        }
                    }
                }

                this.input.name = ud?ud.name:''
                this.input.phone = ud?ud.phone:""
                this.input.old_password = this.ud?this.ud.old_password:"" 
                this.dialog_update_user=!this.dialog_update_user
            },

            p_value(permission){
                if(!permission){return false}
                if(!permission.allow){return false}
                let p = permission.allow 
                return p 
            },

            pageLoad(t){
                if (!t) {
                    t=400
                }
                setTimeout(()=>{
                    let us = this.loggedUser 
                    let ps = this.processes
                    let ld = this.loading
                    let res = this.responses
                    //this.page_show = false 

                    //Check proccess 
                    if (ps) {
                        let logging = ps.find(process=>{
                            return process.name == 'logging'
                        })
                        let getting = ps.find(process=>{
                            return process.name == 'getting/usersDetail'
                        })
                        let updating = ps.find(process=>{
                            return process.name == 'updating/user'
                        }) 

                        if (logging) {
                            this.page_show =false
                        }else{
                            this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                        }

                        if (getting) {
                            this.not.notDialogP(true,false,'updating...')
                        }else{
                            this.not.notDialogP(false)
                        }

                        if (updating) {
                            this.not.notDialogP(true,true,'Saving...')
                            this.input.loading = true
                        }else{
                            // this.not.notDialogP(false)
                            // this.input.loading = false
                        }  
                    }else{
                        this.page_show = this.not.ACCESS_PAGE(this.$route.name)
                    }

                    //check response
                    if (res.res==='updating/user/successful') { 
                        this.not.notDialog(true,true,'Successful','successfully updated.','','OK',{code:pageName+'=UPDATE-USER-SUCCESS'})
                        this.input.loading = false
                        this.not.notDialogP(false) 
                        this.not.restartResponses() 
                    }else if (res.res==='updating/user/error'){ 
                        this.not.notDialog(true,true,'Not Successful','Error while updating the user. make sure your password is correct or contact admin','','OK',{code:pageName+'=UPDATE-USER-ERROR'})
                        this.input.loading = false
                        this.not.notDialogP(false)
                        this.not.restartResponses()
                    } 
                },t)
            }
        }, 
        watch: {
            us(v){
                
            },
            loading(value){
                this.pageLoad(1)
            },
            processes(value){
                this.pageLoad(1)
            },
            responses(value){
                this.pageLoad(1) 
            } 
        },
    } 
    
</script>
 
